module.exports = __webpack_public_path__ + "img/animation_icon_3.ffaf7b93.webp";